export default { 
  HomeUser: require('./HomeUser').default,
  DetailUser: require('./DetailUser').default,
  StudiUser: require('./StudiUser').default,
  Prakerja: require('./prakerja').default,
}